import { useState, useCallback } from "react";
/**
 * Хук для открытия/закрытия сайдбара
 * @param {boolean} initialState - изначальное состояние сайдбара (закрыт)
 * @param {boolean} isCollapsed - текущее состояние сайдбара
 */
export const useSidebar = (initialState = true) => {
  const [isCollapsed, setIsCollapsed] = useState(initialState);

  const open = useCallback(() => {
    setIsCollapsed(false);
  }, []);

  const close = useCallback(() => {
    setIsCollapsed(true);
  }, []);

  const toggle = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, []);

  return {
    isCollapsed,
    open,
    close,
    toggle,
  };
};
